import axios from 'axios';
import MyForm from 'components/Layout/MyForm';
import TopBar from 'components/Layout/TopBar';
import {logError, transformDatas} from 'components/Utils/FormatData';
import {URL_API} from 'utils/globalConfig';
import React, {useEffect, useState} from 'react';
import {useAlert} from 'react-alert';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router';
import {ClipLoader} from 'react-spinners';
import useAuthz from '../../hooks/useAuthz';
import MyButton from "../../components/Layout/MyButton";
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { PROFIL } from '../../constants/enum';

const MonProfil = (props) => {
	const defaultUserDetail = {};
	const navigate = useNavigate();
	const alert = useAlert();
	const [authz, user, profil] = useAuthz();
	const [isLoading, setIsLoading] = useState(true);
	const [userDetail, setUserDetail] = useState(defaultUserDetail);
	const [profils, setProfils] = useState([]);
	const dispatch = useDispatch();
	const formInterne = [
		{
			id: 'login',
			name: 'login',
			label: 'LOGIN',
			type: 'text',
			required: true,
			readOnly: true,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'nom',
			name: 'nom',
			label: 'NOM',
			type: 'text',
			required: true,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'prenom',
			name: 'prenom',
			label: 'PRÉNOM',
			type: 'text',
			required: true,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'adresse',
			name: 'adresse',
			label: 'ADRESSE',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'complement_adresse',
			name: 'complement_adresse',
			label: 'COMPLÉMENT ADRESSE',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'code_postal',
			name: 'code_postal',
			label: 'CODE POSTAL',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'commune',
			name: 'commune',
			label: 'COMMUNE',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'pays',
			name: 'pays',
			label: 'PAYS',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'telephone_1',
			name: 'telephone_1',
			label: 'N° TÉLÉPHONE',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'telephone_2',
			name: 'telephone_2',
			label: 'N° TÉLÉPHONE 2',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'fax',
			name: 'fax',
			label: 'FAX',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		}
	];
	const formExterne = [
		{
			id: 'login',
			name: 'login',
			label: 'LOGIN',
			type: 'text',
			required: true,
			readOnly: true,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'new_password_1',
			name: 'new_password_1',
			label: 'NOUVEAU MOT DE PASSE',
			type: 'password',
			required: true,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'new_password_2',
			name: 'new_password_2',
			label: 'CONFIRMER LE NOUVEAU MOT DE PASSE',
			type: 'password',
			required: true,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'num_siren',
			name: 'num_siren',
			label: 'N° SIRET',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'num_tva',
			name: 'num_tva',
			label: 'N° TVA',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'raison_sociale',
			name: 'raison_sociale',
			label: 'RAISON SOCIALE',
			type: 'text',
			required: true,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'adresse',
			name: 'adresse',
			label: 'ADRESSE',
			type: 'text',
			required: true,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'complement_adresse',
			name: 'complement_adresse',
			label: 'COMPLÉMENT ADRESSE',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'code_postal',
			name: 'code_postal',
			label: 'CODE POSTAL',
			type: 'text',
			required: true,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'commune',
			name: 'commune',
			label: 'COMMUNE',
			type: 'text',
			required: true,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'pays',
			name: 'pays',
			label: 'PAYS',
			type: 'text',
			required: true,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'telephone_1',
			name: 'telephone_1',
			label: 'N° TÉLÉPHONE',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'telephone_2',
			name: 'telephone_2',
			label: 'N° TÉLÉPHONE 2',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		},
		{
			id: 'fax',
			name: 'fax',
			label: 'FAX',
			type: 'text',
			required: false,
			readOnly: false,
			style: {width: '100%', margin: '20px'},
		}
	];

	// Chargement du composant
	useEffect(() => {
		document.title = `TE - Mon Profil`;
		callApis();
	}, []);

	// Gestion du changement des valeurs du form
	const handleChangeValue = (event) => {
		setUserDetail({...userDetail, [event.target.name]: event.target.value});
	};

	// Annulation du formulaire
	const handleCancel = () => {
		navigate('/accueil');
	};

	// Validation du formulaire
	const handleValid = () => {
		if (checkForm()) {
			axios({
				method: 'post',
				url: URL_API + '/utilisateur/edition',
				data: userDetail, params: {userAction: user.user_id}
			})
				.then((res) => {
					alert.removeAll();
					alert.success('Votre compte a bien été mis à jour');
					updateLocalStorageInfos(res.data);
					navigate('/');
				})
				.catch((error) => {
					logError(alert, error);
				});
		}
	};

	// Appel à l'ensemble des APIs
	const callApis = () => {
		const promiseProfilInfo = axios({method: 'get', url: `${URL_API}/utilisateur/detail-id?id=${user.user_id}`});
		const promiseListeProfil = axios({method: 'get', url: `${URL_API}/utilisateur/liste-profil`});

		Promise.all([promiseProfilInfo, promiseListeProfil])
			.then(function (values) {
				setUserDetail(values[0].data);
        setProfils(values[1].data.map((p) => ({ ...p, label: p.type })));
				setIsLoading(false);
			})
			.catch(function (err) {
				logError(alert, err);
			});
	};

	// Méthode de contrôle des données du formulaire
	const checkForm = () => {
		let formIsValid = true;

		// Compte interne
		if (profil.profil < 5) {
			if (userDetail.login === '' || userDetail.nom === '' || userDetail.prenom === '' || userDetail.email === '') {
				formIsValid = false;
				alert.error("Veuillez renseigner l'ensemble des champs obligatoires avant de continuer");
			}
		}

		// Compte externe
		if (profil.profil >= 5) {
			if (
				userDetail.login === '' ||
				userDetail.new_password_1 === '' ||
				userDetail.new_password_2 === '' ||
				userDetail.num_siren === '' ||
				userDetail.raison_sociale === '' ||
				userDetail.adresse === '' ||
				userDetail.code_postal === '' ||
				userDetail.commune === '' ||
				userDetail.pays === ''
			) {
				formIsValid = false;
				alert.error("Veuillez renseigner l'ensemble des champs obligatoires avant de continuer");
			}
		}

		if (userDetail.new_password_1 !== userDetail.new_password_2) {
			alert.error('Les mots de passe ne sont pas identiques');
			formIsValid = false;
		} else if (userDetail.new_password_1 && userDetail.new_password_1.length < 12) {
			alert.error('Le mot de passe doit contenir au moins 12 caractères');
			formIsValid = false;
		} else if (userDetail.new_password_1 && !userDetail.new_password_1.match(/^(?=.*?[A-Z])(?=.*?[a-z])((?=.*?[0-9])|(?=.*?[#?!@$ %^&*-]))/)) {
			alert.error('Le mot de passe doit contenir au moins une majuscule, une minuscule et un chiffre ou un caractère spécial');
			formIsValid = false;
		}

		return formIsValid;
	};

	// Update localstorage infos
	const updateLocalStorageInfos = (datas) => {
		window.localStorage.setItem('user', JSON.stringify(datas));
		dispatch({type: 'UPDATE_USER_INFO', payload: datas});
	};

	return (
		<div style={{height: '100%'}}>
			<TopBar title='Mon profil' className='topbar-contenu' color={props.params.color} buttons={null}/>

			<div className='row' style={{alignItems: isLoading ? 'center' : '', height: 'calc(100% - 50px)', overflowY: 'auto'}}>
				<ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'}/>

				{!isLoading && (
					<div className='form-content-center' style={{minWidth: 750}}>
						<MyForm data={userDetail} setData={setUserDetail}
										form={profil.profil < 5 ? formInterne : formExterne} onChange={handleChangeValue}/>

						<div className='row' style={{width: '100%', margin: '20px'}}>
							<MyButton onClick={handleCancel} style={'buttonDefault'} label={'Annuler'} icon={faXmark}/>
							<MyButton onClick={handleValid} style={'buttonValidation'} label="Valider l'édition" icon={faCheck}/>

						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default MonProfil;
